// 101.48 -> '101-15/32"'. Nearest 1/32, reduced (14/32 -> 7/16), with carry
// (31.99 -> 32").
export const toFraction32 = (inches: number): string => {
	const t = Math.round(inches * 32);
	const whole = Math.floor(t / 32);
	let num = t - whole * 32;
	if (num === 0) return `${whole}"`;
	let den = 32;
	while (num % 2 === 0) {
		num /= 2;
		den /= 2;
	}
	return `${whole}-${num}/${den}"`;
};

// 101.4844 -> '101.48" · 101-15/32"' (the plant reads both).
export const withFraction32 = (
	inches: number | null | undefined,
	fallback = "",
): string => {
	if (inches === null || inches === undefined) return fallback;
	const n = Number(inches);
	if (Number.isNaN(n)) return fallback;
	return `${n.toFixed(2)}" · ${toFraction32(n)}`;
};

// Tolerance band: '101.14" – 101.23" · 101-9/64" – 101-15/64"'.
export const rangeWithFraction32 = (min: number, max: number): string =>
	`${min}" – ${max}" · ${toFraction32(min)} – ${toFraction32(max)}`;
